import {Trans, useTranslation} from "react-i18next";
import {isNil} from "app/utils/stdlib";
import {DateDisplay} from "app/employee/DateDisplay";
import {IonBadge} from "@ionic/react";
import type {OrganizerDocumentFragment} from "app/gql/graphqlSchema";

const NoExpiration = () => {
  const {t} = useTranslation();
  return <IonBadge color="success">{t("organizer.never-expires", {defaultValue: "Безсрочен"})}</IonBadge>;
};

export const Validity = ({document}: {document: OrganizerDocumentFragment}) => {
  const {t} = useTranslation();
  if (!isNil(document.validFrom) && !isNil(document.validUntil)) {
    return (
      <Trans
        components={{
          ValidFrom: <DateDisplay dt={document.validFrom} />,
          ValidUntil: <DateDisplay dt={document.validUntil} />
        }}
        i18nKey="organizer.valid-from-until"
        t={t}
      />
    );
  } else if (!isNil(document.validFrom)) {
    return (
      <Trans
        components={{ValidFrom: <DateDisplay dt={document.validFrom} />, NoExpiration: <NoExpiration />}}
        i18nKey="organizer.valid-from"
        t={t}
      />
    );
  } else if (!isNil(document.validUntil)) {
    return (
      <Trans components={{ValidUntil: <DateDisplay dt={document.validUntil} />}} i18nKey="organizer.valid-until" t={t} />
    );
  } else {
    return <NoExpiration />;
  }
};
